/* eslint guard-for-in: 0 */
import clone from 'shallow-clone';
import typeOf from 'kind-of';
import * as urlParameterNames from '../consts/urlParameterNames';
function cloneDeep(val, instanceClone) {
    switch (typeOf(val)) {
        case 'object':
            return cloneObjectDeep(val, instanceClone);
        case 'array':
            return cloneArrayDeep(val, instanceClone);
        default: {
            return clone(val);
        }
    }
}
function cloneObjectDeep(val, instanceClone) {
    if (typeof instanceClone === 'function') {
        return instanceClone(val);
    }
    if (typeOf(val) === 'object') {
        const res = new val.constructor();
        for (const key in val) {
            res[key] = cloneDeep(val[key], instanceClone);
        }
        return res;
    }
    return val;
}
function cloneArrayDeep(val, instanceClone) {
    const res = new val.constructor(val.length);
    for (let i = 0; i < val.length; i++) {
        res[i] = cloneDeep(val[i], instanceClone);
    }
    return res;
}
function createParam(name, value) {
    return `${name}=${encodeURIComponent(value)}`;
}
function isFindWebsiteDefaults(findWebsite) {
    return findWebsite && findWebsite.isNeedWebsite === true;
}
export function stateToUrlParams(logoState, debugApp, referralAdditionalInfo, referralInfo, additionalParams) {
    const arrParams = [];
    let result = '';
    if (logoState) {
        const { companyDetails, industry, tags, socialNetworks, logoId, prints, findWebsite, selectedZoeTemplate, selectedWebsiteId, designId, chatMetasite } = logoState;
        if (companyDetails && !logoId && !designId) {
            const { companyName, tagLine } = companyDetails;
            if (companyName) {
                arrParams.push(createParam('companyName', companyName));
            }
            if (tagLine) {
                arrParams.push(createParam('tagLine', tagLine));
            }
        }
        if (industry) {
            const { industryId, structureId, label, isCustom } = industry;
            const industryValue = `${industryId !== null && industryId !== void 0 ? industryId : ''}_${structureId !== null && structureId !== void 0 ? structureId : ''}_${label !== null && label !== void 0 ? label : ''}`.toLowerCase();
            arrParams.push(createParam('industry2', JSON.stringify({ industry: industryValue, isCustom })));
        }
        if (tags && Array.isArray(tags) && tags.length) {
            arrParams.push(createParam('tags', tags.join(',')));
        }
        if (socialNetworks && Array.isArray(socialNetworks) && socialNetworks.length) {
            arrParams.push(createParam('socialNetworks', socialNetworks.join(',')));
        }
        if (typeof selectedWebsiteId === 'number' && selectedWebsiteId > -1) {
            arrParams.push(createParam('selectedWebsiteId', selectedWebsiteId));
        }
        if (logoId) {
            arrParams.push(createParam('logoId', logoId));
        }
        if (designId && !additionalParams.designId) {
            arrParams.push(createParam('designId', designId));
        }
        if (prints) {
            const { p, printSuffix } = prints;
            if (p) {
                arrParams.push(createParam('p', p));
            }
            if (printSuffix) {
                arrParams.push(createParam('printSuffix', printSuffix));
            }
        }
        if (findWebsite && !isFindWebsiteDefaults(findWebsite)) {
            arrParams.push(createParam('findWebsite', JSON.stringify(findWebsite)));
        }
        if (!logoId && !designId && selectedZoeTemplate) {
            const { id, iconId, iconSource, iconUrl, colorPaletteEntityId, designTemplate } = selectedZoeTemplate;
            if (id) {
                arrParams.push(createParam(urlParameterNames.ZOE_LOGO_TEMPLATE_ID_PARAMETER_NAME, id));
            }
            if (iconId && iconSource) {
                arrParams.push(createParam(urlParameterNames.ZOE_LOGO_TEMPLATE_ICON_ID_PARAMETER_NAME, iconId));
                arrParams.push(createParam(urlParameterNames.ZOE_LOGO_TEMPLATE_ICON_SOURCE_PARAMETER_NAME, iconSource));
            }
            else if (iconUrl) {
                arrParams.push(createParam(urlParameterNames.ZOE_LOGO_TEMPLATE_ICON_URL_PARAMETER_NAME, iconUrl));
            }
            if (colorPaletteEntityId) {
                arrParams.push(createParam(urlParameterNames.ZOE_LOGO_TEMPLATE_COLOR_PALETTE_ENTITY_ID_PARAMETER_NAME, colorPaletteEntityId));
            }
            if (designTemplate && designTemplate.id) {
                arrParams.push(createParam(urlParameterNames.ZOE_DESIGN_TEMPLATE_ID_PARAMETER_NAME, designTemplate.id));
            }
        }
        if (chatMetasite) {
            arrParams.push(createParam('chatMetasite', chatMetasite));
        }
    }
    if (referralAdditionalInfo) {
        arrParams.push(createParam('referralAdditionalInfo', referralAdditionalInfo));
    }
    if (referralInfo) {
        arrParams.push(createParam('referralInfo', referralInfo));
    }
    if (debugApp) {
        arrParams.push(createParam('debugApp', debugApp));
    }
    if (additionalParams) {
        Object.keys(additionalParams).forEach(key => {
            arrParams.push(createParam(key, additionalParams[key]));
        });
    }
    if (arrParams.length) {
        result = `?${arrParams.join('&')}`;
    }
    return result;
}
//# sourceMappingURL=logoStateHelpers.js.map